import React, { useState, useEffect } from "react";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import { DownDropArrow } from "../../../assets/images";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon } from "../../Icon";
import "./ReportsDateSelect.scss";
import { addDays, addMonths } from "date-fns";
import {
  getCurrentFinancialYear,
  previousFinancialYear,
} from "../../../utils/commonFunctions";
type AppProps = {
  toggle: boolean;
  setToggle: (data: boolean) => void;
  startDate: string;
  type?: string;
  maxDate?: Date;
  endDate: string;
  clearEndDate?: boolean;
  minDate?: string;
  handleStartDateChange: (date: string) => void;
  handleEndDateChange: (date: string) => void;
  setStartDate?: any;
  setEndDate?: any;
};
const ReportsDateSelect = ({
  toggle,
  setToggle,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  clearEndDate,
  minDate,
  type,
  maxDate,
  setStartDate,
  setEndDate,
}: AppProps) => {
  const currentFY = getCurrentFinancialYear();
  const previousFY = previousFinancialYear();
  const [text, setText] = useState("Current Financial Year");
  const [chooseStartDate, setChooseStartDate] = useState(
    type === "schedulingReport" || type === "approvedCalender"
      ? startDate
      : type === "timesheetSchedulingReport"
      ? moment().subtract(2, "months").startOf("month").format("YYYY-MM-DD")
      : ""
  );
  const [chooseEndDate, setChooseEndDate] = useState(
    type === "schedulingReport" || type === "approvedCalender"
      ? endDate
      : type === "timesheetSchedulingReport"
      ? moment().endOf("month").format("YYYY-MM-DD")
      : ""
  );

  const redirectedStartDate = localStorage.getItem("start_date");
  const redirectedEndDate = localStorage.getItem("end_date");
  useEffect(() => {
    if (type === "schedulingReport" || type === "approvedCalender") {
      setChooseStartDate(startDate);
      setChooseEndDate(endDate);
    }
  }, [startDate, endDate, type]);

  useEffect(() => {
    if (clearEndDate) {
      if (!startDate) {
        setChooseEndDate("");
        setText("Select Date Range");
      }
    }
    //eslint-disable-next-line
  }, [startDate]);

  useEffect(() => {
    if (type === "timesheetSchedulingReport") {
      const twoMonthsAgo = moment()
        .subtract(2, "months")
        .startOf("month")
        .format("YYYY-MM-DD");
      const currentMonthEnd = moment().endOf("month").format("YYYY-MM-DD");
      setChooseStartDate(twoMonthsAgo);
      setChooseEndDate(currentMonthEnd);
      setStartDate(chooseStartDate);
      setEndDate(chooseEndDate);
    }
    //eslint-disable-next-line
  }, [type]);

  useEffect(() => {
    if (
      type !== "dayBook" &&
      type !== "generalLedger" &&
      type !== "timesheetSchedulingReport" &&
      type !== "schedulingReport" &&
      type !== "approvedCalender" &&
      type !== "performanceEvaluation"
    ) {
      handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
      handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
    } else {
      setText("Select Date Range");
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (redirectedEndDate && redirectedStartDate) {
      const startDatetext = new Date(redirectedStartDate).toLocaleString(
        "en-US",
        {
          year: "numeric",
          month: "long",
          day: "numeric",
        }
      );
      const endDatetext = new Date(redirectedEndDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      if (
        redirectedStartDate === `${currentFY?.split("-")[0]}-04-01` &&
        redirectedEndDate === `${currentFY?.split("-")[1]}-03-31`
      ) {
        setText("Current Financial Year");
      } else if (
        redirectedStartDate === `${previousFY?.split("-")[0]}-04-01` &&
        redirectedEndDate === `${previousFY?.split("-")[1]}-03-31`
      ) {
        setText("Previous Financial Year");
      } else {
        setChooseStartDate(redirectedStartDate);
        setChooseEndDate(redirectedEndDate);
        setText(`${startDatetext} - ${endDatetext}`);
      }
    }
    //eslint-disable-next-line
  }, [redirectedStartDate, redirectedEndDate]);

  useEffect(() => {
    if (type === "balanceSheet" && chooseStartDate) {
      const startDatetext = new Date(chooseStartDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      setText(startDatetext);
    } else if (chooseStartDate && chooseEndDate) {
      const startDatetext = new Date(chooseStartDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      const endDatetext = new Date(chooseEndDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      setText(`${startDatetext} - ${endDatetext}`);
    } else if (chooseStartDate) {
      const startDatetext = new Date(chooseStartDate).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    
      setText(`${startDatetext}`);
      handleEndDateChange("");
    } else if (
      chooseStartDate === "" &&
      chooseEndDate === "" &&
      redirectedStartDate === null &&
      redirectedEndDate === null &&
      text !== "Current Financial Year" &&
      text !== "Previous Financial Year"
    ) {
      if (
        type === "dayBook" ||
        type === "generalLedger" ||
        type === "performanceEvaluation"||
        type === "timesheetSchedulingReport" ||
        type === "costOfGoods" ||
        type === "ReceiptAndPayment" ||
        type === "schedulingReport" ||
        type === "approvedCalender"
      ) {
        setText("Select Date Range");
      } else {
        setText("Current Financial Year");
        handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
        handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
      }
    }
    if (
      type === "timesheetSchedulingReport" &&
      chooseStartDate &&
      chooseEndDate
    ) {
      const startDatetext = new Date(chooseStartDate).toLocaleString("en-US", {
        month: "long",
        year: "numeric",
      });
      const endDatetext = new Date(chooseEndDate).toLocaleString("en-US", {
        month: "long",
        year: "numeric",
      });
      setText(`${startDatetext} - ${endDatetext}`);
    } else if (type === "timesheetSchedulingReport" && chooseStartDate) {
      const startDatetext = new Date(chooseStartDate).toLocaleString("en-US", {
        month: "long",
        year: "numeric",
      });
      setText(`${startDatetext}`);
    }
    //eslint-disable-next-line
  }, [chooseEndDate, chooseStartDate]);

  const startDateChange = (date: string) => {
    if (
      type === "dayBook" ||
      type === "generalLedger" ||
      type ==="performanceEvaluation"||
      type === "timesheetSchedulingReport" ||
      type === "costOfGoods" ||
      type === "ReceiptAndPayment" ||
      type === "schedulingReport" ||
      type === "approvedCalender"
    ) {
      setChooseEndDate("");
    }
    if (date === "Invalid date") {
      setChooseStartDate("");
      setChooseEndDate("");
      handleStartDateChange("");
    } else {
      setChooseStartDate(date);
      handleStartDateChange(date);
    }
  };
  const endDateChange = (date: string) => {
    if (date === "Invalid date") {
      setChooseEndDate("");
      handleEndDateChange("");
    } else if (type === "timesheetSchedulingReport" || type === "monthlyLedgerSummary") {
      const endDateOfMonth = moment(date).endOf("month").format("YYYY-MM-DD");
      setChooseEndDate(endDateOfMonth);
      handleEndDateChange(endDateOfMonth);
    } else {
      setChooseEndDate(date);
      handleEndDateChange(date);
    }
  };
  const handleCurrentYear = () => {
    setText("Current Financial Year");
    handleStartDateChange(`${currentFY?.split("-")[0]}-04-01`);
    handleEndDateChange(`${currentFY?.split("-")[1]}-03-31`);
    setToggle(!toggle);
    setChooseStartDate("");
    setChooseEndDate("");
  };
  const handlePreviousYear = () => {
    setText("Previous Financial Year");
    handleStartDateChange(`${previousFY?.split("-")[0]}-04-01`);
    handleEndDateChange(`${previousFY?.split("-")[1]}-03-31`);
    setToggle(!toggle);
    setChooseStartDate("");
    setChooseEndDate("");
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <span
          style={{
            color:
              type === "dayBook" ||
              type === "generalLedger" ||
              type === "timesheetSchedulingReport" ||
              type === "costOfGoods" ||
              type === "ReceiptAndPayment" ||
              type === "schedulingReport" ||
              (type === "approvedCalender" && text === "Select Date Range")
                ? "#7c8db0"
                : "#262a44",
            fontSize:
              (type === "dayBook" ||
                type === "generalLedger" ||
                type === "timesheetSchedulingReport") &&
              text === "Select Date Range"
                ? "12px"
                : "16px",
          }}
        >
          {text}
        </span>{" "}
        <img src={DownDropArrow} alt="" />
      </DropdownToggle>
      <DropdownMenu
        style={{
          width: "350px",
          padding: "31px 25px 30px",
          position: "absolute",
          marginLeft:
            type === "ledgerStatement" || type === "stockStatement"
              ? "-100px"
              : "",
        }}
      >
        <span>
          {type === "timesheetSchedulingReport"
            ? "Select Month"
            : "Select Date"}
        </span>
        <div className="row mt-3">
          <div
            className={`${type === "balanceSheet" ? "col-md-12" : "col-md-6"}`}
          >
            <div className="form-group">
              <div className="date-picker-wraper mr-0">
                <Label className="m-0 p-0 w-100">
                  <DatePicker
                    dateFormat={
                      type === "timesheetSchedulingReport"
                        ? "MMM yyyy" : type === "monthlyLedgerSummary" ? "MM/yyyy"
                        : "dd-MM-yyyy"
                    }
                    selected={
                      chooseStartDate
                        ? new Date(
                            moment(
                              `${chooseStartDate}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      startDateChange(moment(e).format("YYYY-MM-DD"));
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    // showMonthYearPicker
                    showMonthYearPicker={
                      (type === "timesheetSchedulingReport" || type === "monthlyLedgerSummary") ? true : false
                    }
                    name="startDate"
                    placeholderText={
                      type === "balanceSheet" ? "Choose Date" : "Start Date"
                    }
                    className="form-control"
                    minDate={
                      minDate
                        ? new Date(minDate)
                        : type === "schedulingReport"
                        ? new Date("2023-08-01")
                        : null
                    }
                  />
                  <span
                    className="calender-icon"
                    style={{ top: "5px", right: "20px", cursor: "pointer" }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
          {type !== "balanceSheet" && (
            <div className="col-md-6">
              <div className="form-group">
                <div className="date-picker-wraper mr-0">
                  <Label className="m-0 p-0 w-100">
                    <DatePicker
                      dateFormat={
                        type === "timesheetSchedulingReport"
                          ? "MMM yyyy" : type === "monthlyLedgerSummary" ? "MM/yyyy"
                          : "dd-MM-yyyy"
                      }
                      selected={
                        chooseEndDate
                          ? new Date(
                              moment(
                                `${chooseEndDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      onChange={(e: any) => {
                        endDateChange(moment(e).format("YYYY-MM-DD"));
                      }}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="endDate"
                      placeholderText="End Date"
                      className="form-control"
                      disabled={!chooseStartDate}
                      showMonthYearPicker={
                        (type === "timesheetSchedulingReport" || type === "monthlyLedgerSummary") ? true : false
                      }
                      minDate={
                        chooseStartDate
                          ? new Date(
                              moment(
                                `${chooseStartDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      maxDate={
                        type === "dayBook" ||
                        type === "generalLedger" ||
                        type === "timesheetSchedulingReport" ||
                        type === "schedulingReport"
                          ? addDays(new Date(chooseStartDate), 89) :
                          type === "monthlyLedgerSummary" ?
                          addMonths(new Date(chooseStartDate), 11)
                          : maxDate
                          ? maxDate
                          : null
                      }
                    />
                    <span
                      className="calender-icon"
                      style={{ top: "5px", right: "20px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
          )}
        </div>
        {type !== "dayBook" &&
          type !== "generalLedger" &&
          type !== "performanceEvaluation" &&
          type !== "timesheetSchedulingReport" &&
          type !== "schedulingReport" &&
          type !== "approvedCalender" && (
            // type !== "ReceiptAndPayment" &&
            <button
              id="current"
              className="btn btn-outline-secondary col-md-12 mb-2"
              onClick={() => handleCurrentYear()}
              style={{
                color: text === "Current Financial Year" ? "red" : "",
                borderColor: text === "Current Financial Year" ? "red" : "",
              }}
            >
              Current FY
            </button>
          )}
        {type !== "dayBook" &&
          type !== "generalLedger" &&
          type !== "performanceEvaluation" &&
          type !== "timesheetSchedulingReport" &&
          type !== "schedulingReport" &&
          // type !== "ReceiptAndPayment" &&
          type !== "approvedCalender" && (
            <button
              id="previous"
              className="btn btn-outline-secondary col-md-12"
              onClick={() => handlePreviousYear()}
              style={{
                color: text === "Previous Financial Year" ? "red" : "",
                borderColor: text === "Previous Financial Year" ? "red" : "",
              }}
            >
              Previous FY
            </button>
          )}
        {(type === "dayBook" || type === "generalLedger") && (
          <div>
            <small style={{ color: "red", fontSize: "11px" }}>
              Note : You can only choose a 90-day period from the start date.
            </small>
          </div>
        )}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default ReportsDateSelect;
